var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wordingDescription contents",
    attrs: {
      "data-editor-active": ""
    }
  }, [_c('h3', {
    ref: "title",
    staticClass: "title",
    attrs: {
      "data-grid-layout": "title"
    }
  }, [_vm._v("용어설명")]), _c('div', {
    staticClass: "keywords",
    attrs: {
      "data-grid-layout": "content"
    }
  }, [_c('div', {
    ref: "namo",
    staticClass: "textEditorWrap",
    attrs: {
      "id": "namoKeywordEditor"
    },
    domProps: {
      "innerHTML": _vm._s(this.contentText)
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }